import React, { useEffect, useState } from 'react'
import { CButton, CFormCheck, CFormSelect } from '@coreui/react'
import ColorPicker from '../colorPicker/colorPicker'
import { FiAlignCenter, FiAlignLeft, FiAlignRight } from 'react-icons/fi'
import { isEmpty } from 'lodash'

const DesignSettingOverlay = ({
  headline = 'Design Settings',
  subHeadline = 'Customize by adding your brand colors',
  width = '36%',
  disableAnimation = false,
  options = [],
  onCancel = () => {},
  handleSave = () => {},
}) => {
  const [optionsCopy, setOptionsCopy] = useState([])

  useEffect(() => {
    if (!isEmpty(options)) {
      setOptionsCopy(options)
    }
  }, [options])

  const handleInputChange = (value, parentKey, childKey) => {
    const parentEleIndex = optionsCopy.findIndex((ele) => ele.key === parentKey)

    if (parentEleIndex > -1) {
      let tempParentArr = optionsCopy
      let parentObj = tempParentArr[parentEleIndex]

      const childEleIndex = parentObj?.data.findIndex((ele) => ele.key === childKey)
      if (childEleIndex > -1) {
        let tempChildArr = parentObj?.data
        let childObj = tempChildArr[childEleIndex]
        childObj.value = value
        tempChildArr[childEleIndex] = childObj

        tempParentArr[parentEleIndex].data = [...tempChildArr]

        setOptionsCopy([...tempParentArr])
      }
    }
  }

  const getElement = (data, parentKey, index) => {
    if (data.type === 'FONT') {
      return (
        <div
          style={{ color: '#676767', fontSize: '11px' }}
          className="d-flex justify-content-between align-items-center my-3 "
        >
          <p className="mb-0">{data.name}</p>
          <CFormSelect
            style={{ color: '#676767', fontSize: '11px', width: '53.5%' }}
            className="btn-focus-none"
            value={data.value}
            onChange={(e) => handleInputChange(e.target.value, parentKey, data?.key)}
          >
            <option value={'Arial'}>Arial</option>
            <option value={'Verdana'}>Verdana</option>
            <option value={'Tahoma'}>Tahoma</option>
            <option value={'Trebuchet MS'}>Trebuchet MS</option>
            <option value={'Times New Roman'}>Times New Roman</option>
            <option value={'Georgia'}>Georgia</option>
            <option value={'Garamond'}>Garamond</option>
            <option value={'Courier New'}>Courier New</option>
            <option value={'Brush Script MT'}>Brush Script MT</option>
          </CFormSelect>
        </div>
      )
    }
    if (data.type === 'COLOR') {
      return (
        <div
          style={{ color: '#676767', fontSize: '11px' }}
          className="d-flex justify-content-between align-items-center my-3 "
        >
          <p className="mb-0">{data.name}</p>
          <div className="relative">
            <ColorPicker
              value={data?.value ? data.value : '#000000'}
              position={
                optionsCopy.length > 2 && index === optionsCopy.length - 1
                  ? 'right-[25%] top-[-100%]'
                  : 'right-0'
              }
              onChange={(color) => handleInputChange(color, parentKey, data?.key)}
            />
          </div>
        </div>
      )
    }
    if (data.type === 'FONT_FORMAT') {
      return (
        <div
          style={{ color: '#676767', fontSize: '11px' }}
          className="d-flex justify-content-between align-items-center my-2 "
        >
          <p className="mb-0">{data.name}</p>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ fontSize: '13px', width: '53.5%' }}
          >
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '3px',
                color: data.value === 'font-bold' ? '#fff' : '#070707',
                background: data.value === 'font-bold' ? '#000000' : '#fff',
              }}
              className="font-bold border justify-center d-flex items-center cursor-pointer"
              onClick={() => handleInputChange('font-bold', parentKey, data?.key)}
            >
              B
            </div>
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '3px',
                color: data.value === 'italic' ? '#fff' : '#070707',
                background: data.value === 'italic' ? '#000000' : '#fff',
              }}
              className="italic border justify-center d-flex items-center cursor-pointer"
              onClick={() => handleInputChange('italic', parentKey, data?.key)}
            >
              I
            </div>
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '3px',
                color: data.value === 'underline' ? '#fff' : '#070707',
                background: data.value === 'underline' ? '#000000' : '#fff',
              }}
              className="underline border justify-center d-flex items-center cursor-pointer"
              onClick={() => handleInputChange('underline', parentKey, data?.key)}
            >
              U
            </div>
          </div>
        </div>
      )
    }
    if (data.type === 'FONT_ALIGNMENT') {
      return (
        <div
          style={{ color: '#676767', fontSize: '11px' }}
          className="d-flex justify-content-between align-items-center my-3 "
        >
          <p className="mb-0">{data.name}</p>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ fontSize: '13px', width: '53.5%' }}
          >
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '3px',
                background: data.value === 'left' ? '#000000' : '#fff',
              }}
              className="font-bold border justify-center d-flex items-center cursor-pointer"
              onClick={() => handleInputChange('left', parentKey, data?.key)}
            >
              <FiAlignLeft
                style={{ color: data.value === 'left' ? '#fff' : '#070707' }}
                className="w-4 "
              />
            </div>
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '3px',
                background: data.value === 'center' ? '#000000' : '#fff',
              }}
              className="font-bold border justify-center d-flex items-center cursor-pointer"
              onClick={() => handleInputChange('center', parentKey, data?.key)}
            >
              <FiAlignCenter
                style={{ color: data.value === 'center' ? '#fff' : '#070707' }}
                className="w-4 "
              />
            </div>
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '3px',
                background: data.value === 'right' ? '#000000' : '#fff',
              }}
              className="font-bold border justify-center d-flex items-center cursor-pointer"
              onClick={() => handleInputChange('right', parentKey, data?.key)}
            >
              <FiAlignRight
                style={{ color: data.value === 'right' ? '#fff' : '#070707' }}
                className="w-4 "
              />
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <div style={{ background: '#00000020' }} className="w-100 h-100 absolute z-10" />
      <div
        style={{
          width: width,
          zIndex: '30',
          // paddingTop: '47px',
          // paddingBottom: '65px',
          paddingLeft: '0px',
          paddingRight: '0px',
        }}
        className={`preview-slider ${
          !disableAnimation && 'preview-slider-animation'
        } d-flex flex-col justify-between items-stretch`}
      >
        <div style={{ height: '5%' }} />
        <div style={{ height: '87%' }} className="w-100 ">
          <div
            className="text-right w-full"
            style={{
              paddingLeft: '25px',
              paddingRight: '23px',
              height: '6%',
              border: '0.5px solid transparent',
            }}
          >
            <h5
              style={{
                color: '#191818',
                fontSize: '20px',
                fontWeight: '700',
              }}
            >
              {headline}
            </h5>
            <p style={{ fontSize: '12px' }}>{subHeadline}</p>
          </div>
          <div
            className="d-flex items-center w-full"
            style={{ paddingLeft: '25px', paddingRight: '23px', height: '12%' }}
          >
            <div
              className="d-flex justify-content-center align-items-center rounded-1 overflow-hidden w-full"
              style={{ border: '0.5px solid #707070' }}
            >
              <CFormCheck
                className="preview-cformcheck w-50"
                style={{ height: '110px', fontSize: '12px' }}
                type="radio"
                id="flexRadioDefault1"
                label="Default"
                value="Default"
                checked={true}
                onChange={() => null}
                disabled={false}
              />
              <CFormCheck
                className="preview-cformcheck w-50"
                style={{ height: '110px', fontSize: '12px' }}
                type="radio"
                id="flexRadioDefault2"
                label="Advanced"
                value="Advanced"
                checked={false}
                onChange={() => null}
                disabled={true}
              />
            </div>
          </div>
          <div
            style={{
              height: '82%',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
            className=" custom-scrollbar-vertical  w-100"
          >
            {!isEmpty(optionsCopy) &&
              optionsCopy.map((info, idx) => (
                <div key={idx}>
                  <p
                    style={{
                      fontSize: '12px',
                      background: '#e2e2e2',
                      paddingLeft: '25px',
                      paddingRight: '23px',
                    }}
                    className="w-full mb-0 font-semibold"
                  >
                    {info.title}
                  </p>
                  <div style={{ paddingLeft: '25px', paddingRight: '23px' }} className="relative">
                    {info.data.map((ele) => getElement(ele, info.key, idx))}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div
          style={{ height: '6%', paddingRight: '23px' }}
          className="  d-flex justify-end items-center"
        >
          <CButton
            style={{
              color: 'black',
              border: '0.5px solid black',
              // padding: '7px 15px',
              width: '64.5px',
              height: '29.5px',
              fontSize: '12px',
            }}
            className=" bg-white mx-3 rounded btn-focus-none bold"
            onClick={onCancel}
          >
            Cancel
          </CButton>
          <CButton
            style={{
              backgroundColor: '#20211c',
              // padding: '7px 15px',
              width: '65px',
              height: '30px',
              fontSize: '12px',
            }}
            className=" rounded btn-focus-none bold"
            onClick={() => handleSave(optionsCopy)}
          >
            Save
          </CButton>
        </div>
      </div>
    </div>
  )
}

export default DesignSettingOverlay
